import { SidebarElement } from 'sidebarjs';

(function ($) {
	$(document).ready(function () {
		const menuResponsive = new SidebarElement({
			position: 'left'
		});
		const menuResponsiveMarkup = $('.nav-responsive');
		const menuResponsiveButton = $('.nav-responsive__button');
		const menuResponsiveItemsWithChildren = $('.nav-responsive .menu-item-has-children');

		const menuResponsiveButtonSubmenuMarkup = `
			<button class="sub-menu__button open">
				<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">
					<path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
	  			</svg>
			</button>
		`;

		menuResponsiveMarkup.css('display', 'unset');

		menuResponsiveButton.click(function () {
			menuResponsive.toggle();
		});

		menuResponsiveItemsWithChildren.append(menuResponsiveButtonSubmenuMarkup);

		const menuResponsiveButtonSubmenu = $('.nav-responsive .sub-menu__button');

		menuResponsiveButtonSubmenu.click(function () {
			if ($(this).hasClass('open')) {
				$(this).siblings('.sub-menu').addClass('opened');
			}

			if ($(this).hasClass('close')) {
				$(this).siblings('.sub-menu').removeClass('opened');
			}

			$(this).toggleClass('open');
			$(this).toggleClass('close');
		});
	});
})(jQuery);
